// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2105":"cc59ec8a5971d8f2","4804":"ffd8182d96f4d108"}[chunkId] + ".css";
};